<template>
  <div class="gray-back page-step3" style="padding: 0.2rem 0 8rem 0">
    <van-form @submit="onSubmit" @failed="onFailed">
      <van-divider>食宿安排</van-divider>
      <van-divider v-if="qunQrcodeDisplayList.length">群二维码</van-divider>
      <div v-if="qunQrcodeDisplayList.length" class="qrcode-block">
        <div v-for="(url, idx) in qunQrcodeDisplayList" :key="idx" class="qrcode-item">
          <img class="qrcode-img" :src="url" alt="群二维码"/>
        </div>
      </div>

      <van-cell-group>
        <van-cell input-align="right" title="报名人数" :value="String(shisu_member_count)"/>
        <van-cell
            input-align="right"
            title="房间可入住人数"
            :value="String(orderData.countExceptCaipan)"
        />
        <van-cell
            v-for="(room, rindex) in orderData.list.filter((item) => item.show_caipan === 2)"
            :key="'n-' + rindex"
            :label="room.price + '元/间/天 可住' + room.limit + '人'"
            input-align="right"
            :title="room.name"
        >
          <span v-if="room.edit_admin === 2">
            <van-stepper
                v-model="room.count"
                integer
                :min="0"
                :max="room.stock > 0 ? room.last_stock : 999999999"
                @change="countChange"
            />
          </span>
          <span v-else>
            {{ room.count }}间
            <div class="operate-desc-left">请联系食宿负责人修改</div>
          </span>
        </van-cell>

        <div
            v-if="row.caipan_count > 0 && orderData.list.filter((item) => item.show_caipan === 1).length > 0"
        >
          <van-divider>裁判员食宿安排</van-divider>
          <van-cell
              v-for="(room, rindex) in orderData.list.filter((item) => item.show_caipan === 1)"
              :key="'c-' + rindex"
              input-align="right"
              :title="room.name"
          >
            <span v-if="room.edit_admin === 2">
              <van-stepper
                  v-model="room.count"
                  integer
                  :min="0"
                  :max="room.stock > 0 ? room.last_stock : 1"
                  @change="caipanCountChange(room)"
              />
            </span>
            <span v-else>
              {{ room.count }}间
              <div class="operate-desc-left">请联系食宿负责人修改</div>
            </span>
          </van-cell>
        </div>

        <van-divider>食宿费用</van-divider>
        <van-cell input-align="right" title="食宿费用" :value="orderData.price + '元'"/>
      </van-cell-group>

      <van-notice-bar
          wrapable
          :scrollable="false"
          text="此项费用为房型费用估算（单价×间数×入住天数），最终以确认订单页为准。"
      />

      <div class="savebtn">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal"
            round
            native-type="button"
            @click="goPrev"
        >上一步
        </van-button>
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal"
            round
            native-type="submit"
            :disabled="saveLoading"
            :loading="saveLoading"
            loading-text="提交中..."
        >保存并继续
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<style scoped>
.page-step3 {
  min-height: 100vh;
  box-sizing: border-box;
}

.operate-desc-left {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.qrcode-block {
  padding: 0 0.3rem 0.2rem;
}

.qrcode-item {
  text-align: center;
  margin-bottom: 0.2rem;
}

.qrcode-img {
  width: 70%;
  max-width: 5rem;
  border-radius: 8px;
  display: inline-block;
}
</style>

<script>
import Vue from 'vue';
import {
  Cell,
  CellGroup,
  Form,
  Divider,
  Toast,
  Button,
  Stepper,
  NoticeBar,
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Toast).use(Button).use(Stepper).use(NoticeBar);

export default {
  name: 'AbilityApplyStep3',
  computed: {
    qunQrcodeDisplayList() {
      const single = this.row && this.row.qun_qrcode_url;
      if (single) {
        return [single];
      }
      const list = this.row && this.row.qun_qrcode;
      if (!Array.isArray(list)) {
        return [];
      }
      return list.map(item => item && item.url).filter(Boolean);
    },
  },
  data() {
    return {
      baomingId: 0,
      saveLoading: false,
      row: {
        id: 0,
        user_id: 0,
        saiji: 0,
        saiqu: 0,
        days: 1,
        caipan_count: 0,
        room_type: [],
        room_list: [],
      },
      orderData: {
        list: [],
        price: 0,
        count: 0,
        countExceptCaipan: 0,
      },
      shisu_member_count: 0,
    };
  },
  mounted() {
    document.title = '食宿信息';
    const qid = this.$route.query.id;
    this.baomingId = qid ? parseInt(qid, 10) : 0;
    if (isNaN(this.baomingId) || this.baomingId <= 0) {
      Toast.fail('缺少报名编号');
      return;
    }
    this.fetch();
  },
  methods: {
    goPrev() {
      rbLink({ name: 'AbilityApplyStep2', query: { id: this.baomingId } });
    },
    fetch() {
      const that = this;
      that.$api.get('/api/ability/step3Detail', { id: that.baomingId }, (res) => {
        that.row = res.data;
        that.orderData.price = 0;
        that.orderData.count = 0;
        that.orderData.list = that.row.room_type || [];
        that.orderData.list.forEach((item) => {
          that.$set(item, 'count', 0);
          item.count = 0;
        });
        (that.row.room_list || []).forEach((room) => {
          that.orderData.list.forEach((item) => {
            if (item.id === room.room_id) {
              item.count += 1;
            }
          });
        });
        that.orderData.list.forEach((item) => {
          that.orderData.count += item.limit * item.count;
          that.orderData.price += item.price * item.count * that.row.days;
        });
        that.shisu_member_count = that.row.shisu_member_count || 0;
        that.countChange();
      }, (res) => {
        Toast.fail(res.msg || '加载失败');
      });
    },
    caipanCountChange(item) {
      if (item.count > 0) {
        this.orderData.list.forEach((item2) => {
          if (item2.show_caipan === 1 && item2.id !== item.id) {
            item2.count = 0;
          }
        });
      }
      this.countChange();
    },
    countChange() {
      const that = this;
      that.row.room_list = [];
      that.orderData.count = 0;
      that.orderData.price = 0;
      that.orderData.countExceptCaipan = 0;
      that.orderData.list.forEach((item) => {
        that.orderData.count += item.limit * item.count;
        if (item.show_caipan === 2) {
          that.orderData.countExceptCaipan += item.limit * item.count;
        }
        that.orderData.price += item.price * item.count * that.row.days;
        for (let i = 0; i < item.count; i += 1) {
          that.row.room_list.push({
            name: item.name,
            room_id: item.id,
            limit: item.limit,
            price: item.price,
            member: [],
            saiji: that.row.saiji,
            saiqu: that.row.saiqu,
            user_id: that.row.user_id,
            baoming_id: that.row.id,
          });
        }
      });
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    onSubmit() {
      const that = this;
      let inmember = 0;
      that.orderData.list.forEach((item) => {
        if (item.edit_admin === 2 && item.show_caipan === 2) {
          inmember += item.limit * item.count;
        }
      });
      if (that.shisu_member_count > inmember) {
        Toast.fail('还有' + (that.shisu_member_count - inmember) + '位人员没有分配好房间');
        return;
      }
      if (that.row.caipan_count > 0 && that.orderData.list.filter((item) => item.show_caipan === 1).length > 0) {
        let caipanRoomCount = 0;
        that.orderData.list.forEach((item) => {
          if (item.show_caipan === 1) {
            caipanRoomCount += item.limit * item.count;
          }
        });
        if (caipanRoomCount === 0) {
          Toast.fail('请为裁判分配房间');
          return;
        }
      }
      that.saveLoading = true;
      that.$api.post('/api/ability/step3RoomSave', {
        id: that.row.id,
        list: JSON.stringify(that.row.room_list),
      }, () => {
        that.saveLoading = false;
        Toast.success('保存成功');
        rbLink({ name: 'AbilityApplyStep5', query: { id: that.baomingId } }, 'replace');
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// AbilityApplyStep3.vue?29b9ad22